import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useI18n } from '../../i18n';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';

interface ChallengeContextMenuProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}

export function ChallengeContextMenu({ isOpen, onClose, children }: ChallengeContextMenuProps) {
  const { t, isRTL } = useI18n();
  useEffect(() => {
    if (!isOpen) return;
    const desktop = window.matchMedia('(min-width: 768px)');
    const closeOnDesktop = () => { if (desktop.matches) onClose(); };
    closeOnDesktop();
    desktop.addEventListener('change', closeOnDesktop);
    return () => desktop.removeEventListener('change', closeOnDesktop);
  }, [isOpen, onClose]);

  return (
    <Dialog open={isOpen} onOpenChange={open => { if (!open) onClose(); }}>
      <DialogContent
        dir={isRTL ? 'rtl' : 'ltr'}
        aria-describedby={undefined}
        className="flex h-[min(80dvh,42rem)] max-h-[85dvh] flex-col gap-0 overflow-hidden rounded-3xl border-gray-200/50 bg-white/95 p-0 shadow-2xl backdrop-blur-2xl [&>button]:top-3 [&>button]:flex [&>button]:min-h-11 [&>button]:min-w-11 [&>button]:items-center [&>button]:justify-center [&>button]:rounded-full"
      >
        <div className="shrink-0 border-b border-gray-200/50 px-6 py-5 pe-20">
          <DialogTitle className="text-start text-xl font-semibold text-[#434343]">{t('challenge.title')}</DialogTitle>
        </div>
        <div className="min-h-0 flex-1 overflow-hidden">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
